export default "__VITE_ASSET__BTA54Or4__"